// extracted by mini-css-extract-plugin
export var createdDate = "_le-1";
export var divider = "_le-2";
export var headerDivider = "_le-3";
export var messagesCard = "_le-0";
export var messagesContainer = "_le-6";
export var messagesContainerWrapper = "_le-4";
export var showLeftPanelButton = "_le-8";
export var topButtons = "_le-7";
export var withPadding = "_le-5";